/**
 * Retrieves the value of a specified environment variable.
 *
 * @param {string} name - The name of the environment variable.
 * @returns {*} The value of the environment variable.
 */
export default function getEnv(name: string) {
  // @ts-ignore
  return window?.configs?.[name] || import.meta.env[name]
}
